import { homePageStyles } from "@insite/content-library/Pages/HomePage";
import { css } from "styled-components";

homePageStyles.page = {
    padding: 0,
    css: css`
        width: 100%;
        background-color: #f6f6f6;
    `,
    fullWidth: [true, true, true, true, true],
};
